import { FilterOperator, FilterTypes, OrderDirection } from '@typings/graphql'

export const VOUCHER_GRID_PAGE_SIZE = 10

export const VOUCHER_GRID_BASE_ORDER_FILTER = {
  orderBy: {
    field: 'createdAt',
    direction: OrderDirection.Desc
  },
  filter: [{
    field: 'voucher',
    value: true,
    type: FilterTypes.Boolean,
    operator: FilterOperator.Is
  }]
}
